// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Jp-z","imageAndVideoCount":"Kp-z","imageAndVideoContainer":"Lp-z","viewAllReviews":"Mp-z"};